class FormClientDependenciesManager {
    constructor() {
        $('.js-visibility-dependent-panel').each((_, panel) => {
            const $panel = $(panel);
            const $depField = this.getDependentField($panel);
            if (!$depField.length) {
                console.error('No dependent fields found for panel:');
                console.warn($panel);
                return;
            }
            this.initField($depField);
        });
    }
    fieldOnChange(e) {
        const $field = $(e.target);
        const $panels = this.getDependingPanels($field);
        if (!$panels.length)
            return;
        $panels.each((index, panel) => {
            this.checkPanel($(panel));
        });
    }
    initField($field) {
        const $depField = this.getDependentField($field);
        if ($depField.length) {
            this.initField($depField);
        }
        const $fields = this.getAllInputs($field);
        $fields.off('change click blur keyup', (e) => this.fieldOnChange(e)); // Reset existing events
        $fields.on('change click blur keyup', (e) => this.fieldOnChange(e));
        $fields.trigger('change');
    }
    getDependingPanels($field) {
        const $elements = this.getAllDependingElements($field);
        return $elements.filter('.js-visibility-dependent-panel');
    }
    getAllDependingElements($elem) {
        const parent = this;
        const name = $elem.attr('name');
        if (!name) {
            return $elem;
        }
        const $depElems = $('[data-visibility-depends-on-field-name="' + name + '"]');
        if (!$depElems.length) {
            return $elem;
        }
        let $finalDepElems = $depElems;
        $depElems.each(function (index, depElem) {
            const $toAdd = parent.getAllDependingElements($(depElem));
            $finalDepElems = $($.unique($finalDepElems.add($toAdd).get())); // Merges 2 arrays and removes duplicates
        });
        return $finalDepElems;
    }
    // Returns multiple elements when the field is a radiobutton group
    getDependentField($field) {
        const depFieldName = $field.data('visibility-depends-on-field-name');
        if (!depFieldName)
            return $([]);
        const $depField = $('[name="' + depFieldName + '"]').filter('input,textarea,select');
        if (!$depField.length) {
            console.error('Dependent field with name "' + depFieldName + '" not found.');
            console.warn($field);
            return $([]);
        }
        else {
            return $depField.first();
        }
    }
    getAllInputs($field) {
        const name = $field.attr('name');
        if (!name) {
            console.error('The field has no "name" attribute: "' + name + '"');
            console.warn($field);
            return $field;
        }
        return $('[name="' + name + '"]');
    }
    checkPanel($panel) {
        const $field = this.getDependentField($panel);
        if (!$field.length) {
            console.error('The dependent field could not be found for panel:');
            console.warn($panel);
            return;
        }
        const depCond = this.getFieldCondition($panel);
        if (!depCond)
            return;
        const show = (this.fieldMatchesCondition($field, depCond.name, depCond.val));
        this.togglePanel($panel, show);
    }
    togglePanel(panel, show) {
        const fields = panel.find('input, select, textarea');
        if (show) {
            panel.show();
            fields.removeClass('Panel_NoValidation');
        }
        else {
            panel.hide();
            fields.addClass('Panel_NoValidation');
            // We need to wait 1ms because else JQuery Validation won't trigger our custom errorPlacement() function
            setTimeout(() => {
                fields.trigger('change');
            }, 1);
        }
    }
    fieldMatchesCondition($field, condName, condVal) {
        const $depField = this.getDependentField($field);
        if ($depField.length) {
            const depCond = this.getFieldCondition($field);
            if (!depCond)
                return true;
            const matchesPrequirements = ($depField.length) ? this.fieldMatchesCondition($depField, depCond.name, depCond.val) : true;
            if (!matchesPrequirements)
                return false;
        }
        const condValInt = (condVal) ? parseInt(condVal) : 0;
        const val = this.getFieldVal($field).toString();
        const valInt = (val) ? parseInt(val) : 0;
        try {
            if (condName == 'equals') {
                return (val == condVal);
            }
            else if (condName == 'notequals') {
                return (val != condVal);
            }
            else if (condName == 'empty') {
                return (val == '');
            }
            else if (condName == 'required') {
                return (val !== '');
            }
            else if (condName == 'contains') {
                if (val.indexOf(';') !== -1) {
                    return (val.indexOf(condVal) !== -1);
                }
                return (val.indexOf(condVal) !== -1);
            }
            else if (condName == 'min-number') {
                return (val !== '' && valInt >= condValInt);
            }
            else if (condName == 'max-number') {
                return (val !== '' && valInt <= condValInt);
            }
            else if (condName == 'min-length') {
                return (val.length >= condValInt);
            }
            else if (condName == 'max-length') {
                return (val.length <= condValInt);
            }
            else if (condName == 'true') {
                return (val === 'true');
            }
            else if (condName == 'false') {
                return (val === 'false');
            }
            else {
                console.error('"' + condName + '" is an unknown condition and has been defaulted to "true" on field:');
                console.warn($field);
                return true;
            }
        }
        catch (ex) {
            console.error('The condition check "' + condName + '" has thrown a javascript error and has been defaulted to "true". Fix the condition-value on field:');
            console.warn($field);
            return true;
        }
    }
    getFieldVal($field) {
        const type = $field.attr('type') || 'text';
        if (type == 'radio') {
            const $checkedField = this.getAllInputs($field).filter(':checked');
            return ($checkedField.length) ? $checkedField.val() : '';
        }
        if (type == 'checkbox') {
            const $checkedFields = this.getAllInputs($field).filter(':checked');
            const values = [];
            $checkedFields.each((index, elem) => {
                values.push($(elem).val().toString());
            });
            return values.join(';');
        }
        return $field.val();
    }
    getFieldCondition($field) {
        const $condField = $field.filter('[data-visibility-dependency-condition][data-visibility-dependency-condition-value]');
        if (!$condField.length) {
            console.error('The panel or field has a depency but misses a condition. Field:');
            console.warn($field);
            return null;
        }
        const name = $condField.data('visibility-dependency-condition').toString();
        const val = $condField.data('visibility-dependency-condition-value').toString();
        return { name, val };
    }
}
const formClientDependenciesManager = new FormClientDependenciesManager();
export { FormClientDependenciesManager, formClientDependenciesManager };
